/**
 * Service Worker 注销 (v3.13.39)。
 *
 * 历史教训: SW 预缓存会在每次升级后继续供应旧版 index.html/资源,
 * 造成"新旧构建混载"白屏 (生产阻断 #3 的同族问题)。局域网控制台
 * 不需要离线能力 —— 构建产物全部带内容哈希, HTTP 缓存 + 协商即可。
 * 此处主动注销历史 SW 并清空其缓存, 让存量浏览器自愈。
 */

interface UnregisterOptions {
  enabled?: boolean
}

export function unregisterStaleServiceWorkers(opts: UnregisterOptions = {}): void {
  const { enabled = true } = opts
  if (!enabled) return
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return

  const cleanup = async (): Promise<void> => {
    const regs = await navigator.serviceWorker.getRegistrations()
    for (const reg of regs) {
      await reg.unregister().catch(() => undefined)
    }
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys()
      for (const key of keys) {
        await caches.delete(key).catch(() => undefined)
      }
    }
  }

  if (document.readyState === 'complete') {
    void cleanup()
  } else {
    window.addEventListener('load', () => void cleanup(), { once: true })
  }
}
